"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-nvzk86-0"
})(["width:700px;border-radius:var(--border-radius);overflow:hidden;"]);